export const server =  `https://bot.nefteprodukty.com.ua`;
// export const server =  `https://7c1212bfed7f.ngrok.io`;
